import React from 'react';
import { Box, Typography } from '@mui/material';

const VideoGallery = ({ videos, onSelect }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
    {videos.map((video, idx) => (
      <Box
        key={video.file}
        onClick={() => onSelect(idx)}
        sx={{
          cursor: 'pointer',
          border: '1px solid #ccc',
          borderRadius: 2,
          width: 235,
          background: '#fff',
          overflow: 'hidden',
        }}
      >
        <Box
          component="img"
          src={video.thumbnail}
          alt={video.title}
          sx={{
            width: '100%',
            height: 132,
            objectFit: 'cover',
          }}
        />
        <Typography
          variant="caption"
          sx={{ p: 1, fontWeight: 'bold', textAlign: 'center' }}
        >
          {video.title}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default VideoGallery;
